var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.showFilterTabs(_vm.filterTabs)),function(tab,i){return _c('Tab',{key:tab.id,attrs:{"tab":tab,"is-active":_vm.currentTab && _vm.currentTab.id === tab.id,"is-editable":tab.editable,"data-v-step":i === 3 ? 'filter-tab-last' : 'filter-tab'},on:{"onChangeTab":_vm.onChangeTab}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }